import { SubscribeFormAside } from 'components/SubscribeForm';
import * as React from 'react';
export default {
  SubscribeFormAside,
  React
};